<template>
    <div>
        <v-dialog persistent v-model="dialog" :width="450">
            <v-card style="max-height:90vh" tile>
                <v-toolbar>
                    <v-toolbar-title class="text-primary">رویدادهای {{ date }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn @click="dialog = false" icon="close"></v-btn>
                </v-toolbar>
                <div class="py-3 px-4 text-meta" style="min-height: 50vh; max-height:70vh; overflow:auto">
                    <v-row justify="start" align="center" class="mx-0 mt-0 py-2 mb-0 rounded-lg cursor-pointer" v-for="(item, index) in items" :key="index" @click="()=>{dialog = false; $emit('openEvent', item)}">
                        <v-col cols="auto" :style="{'background-color':item.color}" style="width:15px; height:15px" class="rounded-circle pa-0 ms-2"></v-col>
                        <v-col cols="auto" class="pa-0 ms-4">{{ item.start_date.format('HH:mm') }}</v-col>
                        <v-col cols="" class="vpc_event-title pa-0 ms-4 text-truncate">{{ item.title }}</v-col>
                    </v-row>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
export default {
    data() {
        return {
            items: [],
            dialog: false,
            date: null
        }
    },
    methods: {
        open(items){
            if(items && items.length){
                this.date = items[0].start_date.format('dddd jYYYY/jMM/jDD');
                this.items = items;
                this.dialog = true;
            }
        }
    },
}
</script>
